export default "__VITE_ASSET__Bw3tVX2m__"